import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { requestPasswordReset } from "../../../Store/Apis/ReservationApi";
import LogoBg from "../../../assets/img/Logo-bg.jpg";
import Logo from "../../../assets/img/1699451121.png";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Simple email validation function
  const validateEmail = () => {
    if (!email) {
      setError("Email is required");
      return false;
    }

    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailPattern.test(email)) {
      setError("Invalid email address");
      return false;
    }
    setError("");
    return true;
  };

  // Handle form submission
  const handleRequestCode = async (e) => {
    e.preventDefault();
    
    if (!validateEmail()) {
      return;
    }

    setLoading(true);
    
    try {
      const response = await requestPasswordReset(email);
      
      if (response.status === 200) {
        toast.success(response.message || "Verification code sent successfully!");
        // Navigate to reset password page with email
        navigate("/reset-password", { state: { email } });
      } else {
        toast.error(response.message || "Failed to send verification code");
      }
      
    } catch (error) {
      console.error("Password reset request error:", error);
      toast.error("Failed to send verification code. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleBackToLogin = () => {
    navigate("/login");
  };

  return (
    <div className="main-content main-content-bg mt-0 ps">
      <div
        className="page-header min-vh-100"
        style={{ backgroundImage: `url(${LogoBg})` }}
      >
        <span className="mask bg-gradient-dark opacity-6"></span>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-4 col-md-6">
              <div className="card border-0 mb-0">
                <div className="card-header text-center pt-4 pb-2 bg-transparent">
                  <img src={Logo} className="login-logo" alt="Logo" />
                </div>
                <div className="card-body px-lg-5">
                  <h1 className="fs-5 text-muted mb-3 fw-normal">
                    Forgot Password
                  </h1>
                  <p className="text-sm text-muted mb-4">
                    Enter your email address and we'll send you a verification code to reset your password.
                  </p>
                  <form onSubmit={handleRequestCode}>
                    <div className="form-group mb-3">
                      <label>Email address</label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                          setError(""); // Clear error when user starts typing
                        }}
                      />
                    </div>
                    
                    {error && (
                      <div className="text-danger text-sm mt-2 mb-3">{error}</div>
                    )}
                    
                    <button
                      type="submit"
                      className="btn btn-primary mt-2 mb-3 w-100"
                      disabled={loading}
                    >
                      {loading ? "Sending Code..." : "Request Verification Code"}
                    </button>
                    
                    <div className="text-center">
                      <button
                        type="button"
                        onClick={handleBackToLogin}
                        className="btn btn-link text-primary-faded text-sm p-0"
                      >
                        Back to Login
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
